import { getAccountRoleReassignmentBlockMessage } from "@common/constants/domains/accounting/accountRole";
import { AccountRole } from "@common/types/domains/accounting/account";

export const MEMBER_RESTRICTION_TOOLTIP =
    "You don't have permission to edit the chart of accounts";

// A CoA row can stand for the same account across several businesses, while the
// merge API takes one source account id.
export const MERGE_ACCOUNT_SINGLE_ENTITY_TOOLTIP =
    "Merging an account applies to one business at a time. Select a single business to merge.";

export const MERGE_ACTION_TOOLTIP =
    "Moves historical and future activity into another account, then removes this account.";

// Only role holders have a Reassign role action.
export const MERGE_ACTION_REASSIGN_HINT =
    " Use Reassign role to keep history here and only change future posts.";

export const mergeActionTooltip = (
    role: AccountRole | null | undefined,
): string =>
    role != null && getAccountRoleReassignmentBlockMessage(role) === null
        ? `${MERGE_ACTION_TOOLTIP}${MERGE_ACTION_REASSIGN_HINT}`
        : MERGE_ACTION_TOOLTIP;

// A role is unique per business (uq_account_entity_id_role) and the reassign API
// takes one entity, so a multi-business row is gated to a single-business row.
export const REASSIGN_ROLE_SINGLE_ENTITY_TOOLTIP =
    "Reassigning a role applies to one business at a time. Select a single business to reassign.";

export const REASSIGN_ROLE_OUTCOME_TOOLTIP =
    "Kick automates posting to this account by default. Change the automation so new activity posts to the selected account.";

export const REASSIGN_ROLE_MODAL_CUTOFF_COPY =
    "Posted journal entries stay on this account. New activity posts to the account you select.";

export const buildReassignRoleToastMessage = ({
    sourceName,
    targetName,
}: {
    sourceName: string;
    targetName: string;
}): string =>
    `New activity will post to ${targetName}. Posted journal entries stay on ${sourceName}.`;

// A single display row in the editor can collapse two accounts that live in the
// same business (same name, null code), which merge and remove opening balance
// both refuse. The copy names the situation and stops there: filtering cannot
// split the row, and neither can a rename, because a rename on a collapsed row
// applies to every account behind it.
export const COLLAPSED_SAME_BUSINESS_ROW_TOOLTIP =
    "This row combines more than one account in the same business.";
